import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  actions as personalisationActions,
  selectNumberOfRequiredPersonalisations,
  selectOutstandingPersonalisations,
  selectTrackedEvents,
} from 'src/redux/personalisation';
import { selectPersonalisationOptions } from 'src/redux/selectors';
import { PersonalisationOptions } from '../components/PersonalisationOptions/PersonalisationOptions';

const mapStateToProps = (state: ReduxApplicationState) => ({
  options: selectPersonalisationOptions(state),
  outstandingSelections: selectOutstandingPersonalisations(state),
  totalRequiredPersonalisations: selectNumberOfRequiredPersonalisations(state),
  trackedEvents: selectTrackedEvents(state),
});

const mapDispatchToProps = {
  deselectPersonalisation: personalisationActions.deselectPersonalisation,
  selectPersonalisation: personalisationActions.selectPersonalisation,
  trackInteraction: personalisationActions.trackInteraction,
  trackProgressMilestone: personalisationActions.trackProgressMilestone,
  trackInteractionError: personalisationActions.trackInteractionError,
};

export const PersonalisationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonalisationOptions);
